import { VALIDATE_BILLTO_SUCCESS, VALIDATE_BILLTO_FAILURE } from '../actions';
import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { convertObjectToQueryParams } from 'src/utils/util';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
export default function* getValidateAccountSaga(action) {
    let url = `/occ/v2/${localStorage.getItem('baseSiteId')}`;
    const params = convertObjectToQueryParams(action.payload);
    // const paramsObj =convertObjectToQueryParams( { orderType: action.payload.orderType, sapPartnerId: action.payload.sapPartnerId});
    url += `/aardt/validateAccount?${params}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({
            type: VALIDATE_BILLTO_SUCCESS,
            data: result,
            statusCode: result.statusCode,
            statusMessage: result.statusMessage
        });
    } catch (e) {
        yield logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action?.payload || '',
        });
        yield put({
            type: VALIDATE_BILLTO_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
